import moment from "moment";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { generateCheckInToken_Request, generateOtherServicesToken_Request, rePrintToken_Request } from "../../../../store/actions";
import { EkioskConfigMessageKeys, IAppointment, IbranchTypeCodes, IKIOSKModel, IKioskOtherServiceMenu, IkioskTokenType, KioskMessage } from "../../../../models/kioskModel2";
import { Ilanguages } from "../../../../models/utilitiesModel";
import AppoinementsItems from "../../../kiosk/theme1/components/appoinementsItems";

const Appoinments: React.FC = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation("translations");
    const language: string = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.language || Ilanguages.ENG);
    const appoinementsData: IAppointment[] = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.appointmentsData || []);
    const isWalkIn: IKioskOtherServiceMenu = useSelector((state) => (state.kioskReducer2 as IKIOSKModel)?.isWalkin || undefined);
    const appoinmentType: any = useSelector((state) => (state.kioskReducer2 as IKIOSKModel)?.appoinmenttype || IbranchTypeCodes.CLINICAL);
    const filteredAppoinmentsData = appoinementsData?.filter((x) => x.branchType === appoinmentType) || [];
    const noAppoinmentsFoundmes: KioskMessage = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.kioskConfigdata?.kioskMessage?.find((x) => x?.msgKey === EkioskConfigMessageKeys.NOAPPOINMENTSMES) || undefined);
    let currentDate = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.currentDateAndTime || new Date());
    const otherserviceErrorMessage: string = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.otherserviceErrorMessage || undefined);

    const [iswalkinEmpty, setIswalkinEmpty] = useState(false);
    const handleWalkInrequest = () => {
        isWalkIn ? dispatch(generateOtherServicesToken_Request(IkioskTokenType.WALKIN, isWalkIn?.branchId)) : setIswalkinEmpty(true);
    }
    const handleCheckIn = (values: IAppointment) => {
        values?.serviceStatus === "SCHEDULED" ?
            dispatch(generateCheckInToken_Request(IkioskTokenType.CHECKIN, values.encounterId)) : dispatch(rePrintToken_Request(IkioskTokenType.CHECKIN, values.encounterId));
    };
    console.log("AppoinmentsPagecomponent==>", iswalkinEmpty, appoinmentType, filteredAppoinmentsData);
    const [itemOffSet, setItemOffSet] = useState(1)
    const lastIndex=itemOffSet*5
    const fisrstIndex=lastIndex-5
    const pageCount = Math.ceil(filteredAppoinmentsData.length / 5)
    const currentItem=filteredAppoinmentsData?.slice(fisrstIndex,lastIndex)
    return (
        <div className='Kiosk_appointments'>
            <h2>{t('kiosktranslation.todayAppts' + language)}</h2>
            <span className="appointment-date">{moment(currentDate).format('DD MMM YYYY')}</span>

            <div className="d-flex w-100 gap-2">
              { filteredAppoinmentsData?.length > 5 && <button type="button" className='kiosk_previous_btn' disabled={itemOffSet===1} onClick={()=>setItemOffSet((val)=>val-1)} ><i className="icon_m42kiosk_left_arrow"></i></button>}
                <div className='d-flex flex-grow-1 flex-column gap-4 mt-4'>
                    {filteredAppoinmentsData?.length > 0 &&
                        <>

                            {appoinmentType === IbranchTypeCodes.CLINICAL &&
                                currentItem?.map((item: IAppointment, i) => (
                                    <AppoinementsItems id={item?.appointmentId} key={i} />
                                ))
                            }

                            {[IbranchTypeCodes.PHARMACY, IbranchTypeCodes.RADIOLOGY, IbranchTypeCodes.LAB].includes(appoinmentType) &&
                                <>
                                    <div className='appcard appcard_active align-items-center'>
                                        <div className='card-det'>
                                            <h5>{filteredAppoinmentsData[0]?.branchType === IbranchTypeCodes.PHARMACY ? t("kiosktranslation.pharmacy" + language) : filteredAppoinmentsData[0]?.branchType === IbranchTypeCodes.LAB ? t("kiosktranslation.lab" + language) : filteredAppoinmentsData[0]?.branchType === IbranchTypeCodes.RADIOLOGY && t("kiosktranslation.radilogy" + language)}</h5>
                                        </div>
                                        <button type="button" className='status_card' onClick={() => handleCheckIn(filteredAppoinmentsData[0])}>
                                            {(filteredAppoinmentsData[0]?.serviceStatus === "SCHEDULED") ? t('kiosktranslation.CheckIn' + language) : t('kiosktranslation.reprint' + language)}
                                        </button>
                                    </div>
                                </>
                            }
                        </>
            }
                </div>
               {filteredAppoinmentsData?.length > 5 && <button type="button" className='kiosk_next_btn' disabled={itemOffSet === pageCount} onClick={()=>setItemOffSet((val)=>val+1)}><i className="icon_m42kiosk_right_arrow"></i></button>}
            </div>
            {filteredAppoinmentsData?.length === 0 &&
                <div>
                    <div className="mt-5 mb-2 no-appointments">{(language === Ilanguages.ENG ? noAppoinmentsFoundmes?.msgValueEn : noAppoinmentsFoundmes?.msgValueAr) || (t("kiosktranslation.noschedules" + language))}</div>
                    {/* {appoinmentType === IbranchTypeCodes.CLINICAL && <div className="kiosk_requestwalkin">
                        <i className="icon_m42kiosk_appointments"></i>
                        <button type="button" className='kiosk_generate_btn' onClick={() => handleWalkInrequest()}>{t("kiosktranslation.requestwalkin" + language)}</button>
                    </div>} */}
                    {appoinmentType === IbranchTypeCodes.CLINICAL && isWalkIn &&
                        <>
                            <div className="kiosk_requestwalkin">
                                <i className="icon_m42kiosk_calendar"></i>
                                <button type="button" className='kiosk_generate_btn' onClick={() => handleWalkInrequest()}>{t("kiosktranslation.requestwalkin" + language)}</button>
                            </div>
                            <div className="appointment-info-text">
                                <div><i className="icon_m42kiosk_stopwatch"></i></div>
                                <div className="flex-grow-1">{t("kiosktranslation.walkinMsg" + language)}</div>
                            </div>
                            {otherserviceErrorMessage && <span className="message_response">{otherserviceErrorMessage === 'EM0' ? <p><span>{t('errorMessage.EM1' + language)}<br />{t('errorMessage.EM2' + language)}</span></p> : otherserviceErrorMessage}</span>}
                        </>}

                </div>
            }
            {iswalkinEmpty && <p>{t("kiosktranslation.walkin" + language)}</p>}
        </div>
    )
}
export default React.memo(Appoinments);